/** @jsxImportSource @emotion/react */
import React, { useState } from 'react';
import { Button, Col, Input, Row } from 'reactstrap';

import { ActivityIndicator } from 'react-native-web';
import { connect } from 'react-redux';

import { ICartProduct } from '@ddot/AddToCartCommon/lib/entities';

import ErrorMessage from 'Components/Common/ErrorMessage';
import SuccessMessage from 'Components/Common/SuccessMessage';

import Actions from 'Redux/Actions';
import Selectors from 'Redux/Selectors';
import { IGoldPrice } from 'Redux/slices/home/Entities';
import { RootState } from 'Redux/store';

import NavActions from 'Services/Navigation/Actions';
import LoginSignUpModal from 'Containers/User/LoginSignUpModal';

import { RightArrow } from 'Icons/Icons';
import Utils from 'Lib/Utils';

import {
    buttonIcons,
    addToCartButton,
    checkoutButtonLoading,
} from 'Containers/Products/Styles/ProductDetailsStyles';
import { LoginThunkParams } from 'Redux/slices/auth/controllers/login';
import AssistanceNumber from './AssistanceNumber';
import {
    cartOrderSummaryContainer,
    cartOrderSummaryRows,
    cartOrderSummaryText,
    cartOrderSummaryTitle,
    cartOrderSummaryColumnRight,
    orderTotal,
    promoCodeInput,
    redeemButton,
} from '../Styles/CartStyles';

interface CartProps {
    cartItems: ICartProduct[];
    shippingFee: number;
    currency: string;
    // promoCode: string;
    goldPrice: IGoldPrice;
    stockCheck(products: ICartProduct[], callback: () => void): void;
    stockCheckLoading: boolean;
    stockCheckError: string;
    isLoggedIn: string | undefined;
}

const CartOrderSummary = (props: CartProps): JSX.Element | null => {
    const {
        shippingFee,
        currency,
        cartItems,
        goldPrice,
        stockCheck,
        stockCheckLoading,
        stockCheckError,
        isLoggedIn,
    } = props;

    const [promoCode, setPromoCode] = useState('');
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [loginModalVisible, setLoginModalVisible] = useState(false);

    if (!cartItems.length) return null;

    let subTotal = 0;

    cartItems.forEach(item => {
        const { selectedVariant, quantity } = item;
        const variantPrice = Utils.Jemisys.getItemVariantPrice(item, selectedVariant, goldPrice);
        subTotal += (variantPrice * quantity);
    });

    const totalCost = subTotal + shippingFee;

    const onProceed = () => {
        if (!stockCheckLoading && isLoggedIn) {
            stockCheck(cartItems, () => {
                NavActions.navToShippingAddress();
                window.scrollTo(0, 0);
            });
        } else setLoginModalVisible(true);
    };

    const onAuthorized = () => {
        setLoginModalVisible(false);
    };

    const onSignup = () => {
        setLoginModalVisible(true);
    };

    const checkoutButtonStyle = stockCheckLoading ? checkoutButtonLoading : addToCartButton;

    return (
        <>
            <div css={cartOrderSummaryContainer}>
                <div css={cartOrderSummaryTitle}>Order Summary</div>
                <Row css={cartOrderSummaryRows}>
                    <Col xs={7} sm={8} css={cartOrderSummaryText}>
                        Subtotal (
                        {cartItems.reduce((acc, cur) => acc + cur.quantity, 0)}
                        {' '}
                        items)
                    </Col>
                    <Col
                        xs={5}
                        sm={4}
                        css={[
                            cartOrderSummaryText,
                            cartOrderSummaryColumnRight,
                        ]}
                    >
                        {`${currency} ${Utils.Formatter.currencyFormatter(subTotal)}`}
                    </Col>
                </Row>
                <Row css={cartOrderSummaryRows}>
                    <Col xs={7} sm={8} css={cartOrderSummaryText}>
                        Shipping
                    </Col>
                    <Col
                        xs={5}
                        sm={4}
                        css={[
                            cartOrderSummaryText,
                            cartOrderSummaryColumnRight,
                        ]}
                    >
                        {`${currency} ${Utils.Formatter.currencyFormatter(shippingFee)}`}
                    </Col>
                </Row>
                <hr
                    css={{
                        width: '100%',
                        border: '1px solid #E6DFD8',
                        // marginBottom: '0.6em',
                        '@media(min-width:576px)': {
                        // marginBottom: '3.6em',
                        },
                    }}
                />
                <Row css={cartOrderSummaryRows}>
                    <Col xs={5} className='pr-0' css={orderTotal}>
                        Total
                    </Col>
                    <Col xs={7} css={[orderTotal, cartOrderSummaryColumnRight]}>
                        {`${currency} ${Utils.Formatter.currencyFormatter(totalCost)}`}
                    </Col>
                    <Col xs={12}>
                        <ErrorMessage error={stockCheckError} />
                        <Button
                            css={[checkoutButtonStyle, { width: '100% !important', marginTop: '1.2em' }]}
                            onClick={onProceed}
                            disabled={stockCheckLoading}
                        >
                            {stockCheckLoading ? (
                                <ActivityIndicator color='#064E72' />
                            ) : (
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <p style={{ margin: 0 }}>Proceed to Checkout</p>
                                    <RightArrow css={buttonIcons} />
                                    {/* <img src='/assets/icons/ArrowRight.svg' alt='arrow right' style={{ marginLeft: 10, height: 20 }} /> */}
                                </div>
                            )}
                        </Button>
                    </Col>
                </Row>
            </div>
            <div css={cartOrderSummaryContainer} style={{ marginTop: '2em' }}>
                <div css={cartOrderSummaryTitle}>Promo Code</div>

                <Row css={cartOrderSummaryRows}>
                    <Col xs={7} className='pr-0'>
                        <Input css={promoCodeInput} placeholder='Enter your code' onChange={e => setPromoCode(e.target.value)} />
                    </Col>
                    <Col xs={5} css={cartOrderSummaryColumnRight}>
                        <Button
                            css={redeemButton}
                            onClick={() => {
                                // if (!promoCode) {
                                setError('Invalid promo code');
                                setSuccessMessage('');
                                // } else {
                                //     setSuccessMessage('Discount successfully applied!');
                                //     setError('');
                                // }
                            }}
                        >
                            Apply
                        </Button>
                    </Col>
                    <div style={{ width: '100%', paddingLeft: 15, paddingRight: 15 }}>

                        {error
                        && (
                            <ErrorMessage
                                errorIcon
                                error={error}
                                style={{
                                    padding: 5,
                                    backgroundColor: '#FFE7E7',
                                    borderRadius: 4,
                                }}
                                textStyle={{
                                    fontSize: 12,
                                    fontWeight: 500,
                                    lineHeight: 16,
                                    textAlign: 'left',
                                }}
                            />
                        )}

                        {successMessage
                        && (
                            <SuccessMessage
                                successIcon
                                success={successMessage}
                                style={{
                                    padding: 5,
                                    backgroundColor: '#EEF8EE',
                                    borderRadius: 4,
                                }}
                                textStyle={{
                                    fontSize: 12,
                                    fontWeight: 500,
                                    lineHeight: 16,
                                    textAlign: 'left',
                                }}
                            />
                        )}
                    </div>
                </Row>

            </div>
            <AssistanceNumber mobileNumber='+60 16-773 0338' />
            <LoginSignUpModal
                show={() => setLoginModalVisible(true)}
                hide={() => setLoginModalVisible(false)}
                modal={loginModalVisible}
                onAuthorized={onAuthorized}
                onSignup={onSignup}
                checkOutAsGuest
            />
        </>
    );
};

const mapStateToProps = (state: RootState) => ({
    cartItems: Selectors.getCartItems(state),
    shippingFee: Selectors.getCartShippingFee(state),
    currency: Selectors.getCartCurrency(state),
    promoCode: Selectors.getCartPromoCode(state),
    goldPrice: Selectors.getHomeGoldPrice(state),
    stockCheckLoading: Selectors.getUiStockCheckAttempting(state),
    stockCheckError: Selectors.getUiStockCheckError(state),
    loading: Selectors.getAuthLoginAttempting(state),
    error: Selectors.getAuthLoginError(state),
    forgetPasswordEmailSent: Selectors.getUiAuthIsEmailSent(state),
    forgetPasswordError: Selectors.getAuthForgetPasswordError(state),
    forgetPasswordLoading: Selectors.getAuthForgetPasswordAttempting(state),
    isLoggedIn: Selectors.getAuthAuthToken(state),
});

const mapDispatchToProps = (dispatch: any) => ({
    stockCheck: (products: ICartProduct[], callback: () => void) => dispatch(Actions.uiStockCheck({ products, callback })),
    login: (params: LoginThunkParams) => dispatch(Actions.authLogin(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CartOrderSummary);
